import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import React from 'react';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { PropTypes } from 'prop-types';
import { translateThis } from '../../helpers/language.helper';


const  RichTextEditor = (props) => {
const {onChange, defaultValue = '', toolbarOnFocus = true} = props;
const defaultVal = defaultValue ? EditorState.createWithContent(convertFromRaw(JSON.parse(defaultValue))) : EditorState.createEmpty();
    const [editorState, setEditorState] = React.useState(defaultVal);

    const editor = React.useRef(null);

    /**
     * On change the text
     */
    const onStateChange = () => {
        const value = convertToRaw(editorState.getCurrentContent())
        if (typeof onChange === 'function') {
            onChange(value);
        }
    }

    return (
        <div className='rich-text-editor-wrp'>
            <Editor
            ref={editor}
            placeholder={translateThis('Type here')}
            toolbarOnFocus={toolbarOnFocus}
            toolbar={{
                options: ['inline', 'fontSize', 'list', 'history', 'emoji', 'blockType'],
                }}
                editorState={editorState}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName"
                onEditorStateChange={setEditorState}
                onContentStateChange={onStateChange}
            />
        </div>
    );
}
RichTextEditor.propTypes = {
    onChange: PropTypes.func,
    defaultValue: PropTypes.string,
    toolbarOnFocus: PropTypes.bool
  };
export default RichTextEditor;